module.exports = __webpack_public_path__ + "img/car.4a36fc38.svg";